const OblongResource = (target) => {
  const $body = $('body')
  const $target = $body.find(target)
  if ($target.length) {
    $target.on('click', () => {
      const url = $target.attr('href')
      const string = url.substring(url.lastIndexOf('/') + 1)
      if (!string.toLowerCase().match(/\.(pdf|zip|rar|txt|jpg|png|gif)/g)) {
        return false;
      }
      const tmpArray = string.split('.')
      if (tmpArray.length) {
        window.dataLayer.push({
          event: 'download_resource',
          file_extension: `.${tmpArray[1]}`,
          file_name: string,
          resource_type: 'Document',
          link_url: url,
          // eslint-disable-next-line no-undef
          template_name: gtm_object.template_name,
        })
      }
    })
  }
}

export default OblongResource



// WEBPACK FOOTER //
// ./scripts/components/OblongResource.js